import Btn from '../utils/btn';

const func = $target => {

    var $intraoralOptions = $target.find('#intraoralOption'),
        $intraoralFields = $target.find('[data-type="intraoral-fields"]'),
        $intraoralFiles = $intraoralFields.find('[data-type="intraoral-file"]'),
        $treatmentObjectives = $target.find('#treatmentObjective'),
        $treatmentObjectiveOther = $target.find('[data-type="treatment-objective-other"]'),
        $otherInput = $treatmentObjectiveOther.find('textarea'),
        $btn = new Btn($target.find('button[type="submit"]'));

    console.log('evalutation upload loaded'); 
    
    $intraoralOptions.on('change', function() {

        if(this.value == 'neither') {
            $intraoralFields.removeClass('d-none');
            $intraoralFiles.prop('required',true);
        } else if(!$intraoralFields.hasClass('d-none')) {
            $intraoralFields.addClass('d-none');  
            $intraoralFiles.prop('required',false);        
        }

    });

    $treatmentObjectives.on('change', function() {

        if(this.value == 'other') {
            $treatmentObjectiveOther.removeClass('d-none');
            $otherInput.prop('required',true);
        } else if(!$treatmentObjectiveOther.hasClass('d-none')) {
            $treatmentObjectiveOther.addClass('d-none');
            $otherInput.prop('required',false);
        }
    });
      
    $(".form-control-file").change(function() {
        var input = this,
            $this = $(this),
            totalSize = 0;

        if (input.files && input.files[0]) {
            var reader = new FileReader();
            
            reader.onload = function(e) {
                $this.closest('.card').find('.img-fluid').addClass('d-none');
                $this.closest('.card').find('[data-id="image-preview"]').attr('src', e.target.result).height(144).removeClass('d-none');
            }
            
            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }

        $(".form-control-file").each(function() {
            for (var i = 0; i < this.files.length; i++) {
                totalSize += this.files[i].size;
            }
        });

        console.log(totalSize);

        var valid = totalSize <= 104857600;
        
        if (!valid) {
            console.log('too big');
            $target.find('[data-id="upload-error-message"]').removeClass('d-none');
            $btn.disable();
        } else {
            $target.find('[data-id="upload-error-message"]').addClass('d-none');
            $btn.enable();
        }

    });

    $target.on('submit', function(e) {    
        $target.find('[data-id="upload-message"]').removeClass('d-none');
        $btn.text('Uploading');      
    });

};

export default func;